export default {
  title: 'Gestisci account',
  buttons: {
    save: 'Salva',
    delete: 'Elimina',
  },
};
